import React from 'react'
import { useFindMenu, useTrans } from '@next-nx/hooks'
import { WContainer, Breadcrumbs, MainTitle, MainDescription, Button } from '@next-nx/shared-ui/atoms'
import { Page } from '@next-nx/shared-ui/organisms'
import styles from './ComunicatiTemplate.module.sass'
import { ComunicatiType } from '@next-nx/utils/types'
import Download from '../../atoms/Icons/Download'
import ArrowLeft from '../../atoms/Icons/ArrowLeft'


interface Props {
  comunicato : ComunicatiType
  pagina?: any
}

const ComunicatiTemplate = (props: Props) => {

  const { 
    comunicato = undefined,
    pagina = {},
  } = props


  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={comunicato?.titolo} className={styles.maintitle} />

        <div className={`${styles.description} custom-content`} dangerouslySetInnerHTML={{ __html: comunicato?.descrizione }} />
        {!!comunicato?.allegato && <div className={styles.allegato}><Button newPage={true} label={t("Scarica il documento")} size={'sm'} iconPos={'left'} icon={<Download />} color={'default'} href={comunicato.allegato} variant={'ghost'} /></div>}

        <div className={styles.link}><Button label={t("Torna all'elenco")} iconPos={'left'} icon={<ArrowLeft />} size={'sm'} color={'default'} href={'/comunicati'} variant={'ghost'} /></div>
      </WContainer>
    </Page>
  )
}

export default ComunicatiTemplate
